import { motion } from 'framer-motion'
import { services } from '@/data/services'

export function Services() {
  return (
    <section id="servicos" className="py-20 md:py-28">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <div className="text-sm font-semibold tracking-wider text-brand-cyan uppercase mb-3">
            Nossos serviços
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
            Soluções customizadas de TI pro seu negócio
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative p-6 rounded-xl border border-border/50 bg-card hover:border-brand-cyan/60 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-purple/10 transition-all duration-300"
            >
              <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-brand-purple/0 via-brand-blue/0 to-brand-cyan/10 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="relative">
                <div className="size-10 rounded-lg bg-brand-blue/15 flex items-center justify-center mb-4 group-hover:bg-brand-gradient transition-all">
                  <service.icon className="size-5 text-brand-cyan group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{service.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
